export const AUTHENTIFICATION_LOGIN_BEGIN = 'AUTHENTIFICATION_LOGIN_BEGIN';
export const AUTHENTIFICATION_LOGIN_SUCCESS = 'AUTHENTIFICATION_LOGIN_SUCCESS';
export const AUTHENTIFICATION_LOGIN_FAILURE = 'AUTHENTIFICATION_LOGIN_FAILURE';
export const AUTHENTIFICATION_LOGIN_DISMISS_ERROR = 'AUTHENTIFICATION_LOGIN_DISMISS_ERROR';
export const AUTHENTIFICATION_REGISTER_BEGIN = 'AUTHENTIFICATION_REGISTER_BEGIN';
export const AUTHENTIFICATION_REGISTER_SUCCESS = 'AUTHENTIFICATION_REGISTER_SUCCESS';
export const AUTHENTIFICATION_REGISTER_FAILURE = 'AUTHENTIFICATION_REGISTER_FAILURE';
export const AUTHENTIFICATION_REGISTER_DISMISS_ERROR = 'AUTHENTIFICATION_REGISTER_DISMISS_ERROR';
export const AUTHENTIFICATION_SSO_BEGIN = 'AUTHENTIFICATION_SSO_BEGIN';
export const AUTHENTIFICATION_SSO_SUCCESS = 'AUTHENTIFICATION_SSO_SUCCESS';
export const AUTHENTIFICATION_SSO_FAILURE = 'AUTHENTIFICATION_SSO_FAILURE';
export const AUTHENTIFICATION_SSO_DISMISS_ERROR = 'AUTHENTIFICATION_SSO_DISMISS_ERROR';
export const AUTHENTIFICATION_AUTH_IN = 'AUTHENTIFICATION_AUTH_IN';
export const AUTHENTIFICATION_AUTH_OUT = 'AUTHENTIFICATION_AUTH_OUT';
export const AUTHENTIFICATION_AUTH_EXPIRE = 'AUTHENTIFICATION_AUTH_EXPIRE';



// WEBPACK FOOTER //
// ./src/features/authentification/redux/constants.js